export const LOGISTIC_URL = 'logistics'
